module.exports = __webpack_public_path__ + "static/media/ic-current-loc.a801169b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-current-loc.svg
// module id = 616
// module chunks = 14